import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "../../../Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";

class BritishColumbiaObstetricalFileWeightGainRecommendationSection extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        return (
            <div className="section">
                {this.renderTitle(null, "ObstetricalFile_HealthCanadaWeightGainRecommendationsLabel")}
                <table className="weight-gain-recommendation-table">
                    <thead>
                        <tr>
                            <th rowSpan={2} className="bold">{this.getString("ObstetricalFile_PrepregnancyWeightCategoryLabel")}</th>
                            <th rowSpan={2} className="bold">{this.getString("ObstetricalFile_PrepregnancyBodyMassIndexLabel")}</th>
                            <th colSpan={2} className="bold">{this.MeanRateOfWeightGainLabel()}</th>
                            <th colSpan={2} className="bold">{this.getString("ObstetricalFile_RecommendedTotalWeightGainLabel")}<sup>2</sup></th>
                        </tr>
                        <tr>
                            <th className="bold border-none-left border-none-top">{this.getString("KilogramUnitSymbolLabel")}/{this.getString("ObstetricalFile_WeekAbbrevLabel")}</th>
                            <th className="bold border-none-top">{this.getString("PoundUnitSymbolLabel")}/{this.getString("ObstetricalFile_WeekAbbrevLabel")}</th>
                            <th className="bold border-none-top">{this.getString("KilogramUnitSymbolLabel")}/{this.getString("ObstetricalFile_WeekAbbrevLabel")}</th>
                            <th className="bold border-none-top">{this.getString("PoundUnitSymbolLabel")}/{this.getString("ObstetricalFile_WeekAbbrevLabel")}</th>
                        </tr>
                    </thead>
                    {this.renderWeightGainRecommendationTable()}
                </table>
                <div className="padding-xs-left">
                    <div><sup>1 </sup>{this.getString("ObstetricalFile_RoundedValuesLabel")}</div>
                    <div><sup>2 </sup>{this.getString("ObstetricalFile_CalculationsForTheRecommendedTotalWeightGainLabel")}</div>
                    <div><sup>3 </sup>{this.getString("ObstetricalFile_ALowerWeightGainMayBeAdvisedForWomenLabel")}</div>
                </div>
            </div>
        );
    }

    private MeanRateOfWeightGainLabel(): JSX.Element {
        return (
            <span
                dangerouslySetInnerHTML={{
                    __html: this.getString(
                        "ObstetricalFile_MeanRateOfWeightGainSecondThirdTrimesterLabel",
                        {
                            referenceIndex: "<sup>1</sup>",
                            second: `<sup>${this.getString("SecondSuffixNumberLabel")}</sup>`,
                            third: `<sup>${this.getString("ThirdSuffixNumberLabel")}</sup>`
                        }
                    )
                }}
            />
        );
    }

    private renderWeightGainRecommendationTable(): JSX.Element {
        return (
            <tbody>
                {this.renderRow("Bc_Antenatal_Underweight_row1", "UnderweightLabel", ["< 18.5", "0.5", "1.0", "12.5-18.0", "28-40"])}
                {this.renderRow("Bc_Antenatal_NormalWeight_row2", "NormalWeightLabel", ["18.5-24.9", "0.4", "1.0", "11.5-16.0", "25-35"])}
                {this.renderRow("Bc_Antenatal_Overweight_row3", "OverweightLabel", ["25.9-29.9", "0.3", "0.6", "7.0-11.5", "15-25"])}
                {this.renderRow("Bc_Antenatal_Obese3_row4", "ObeseLabel", ["≥ 30.0", "0.2", "0.5", "5.0-9.0", "11-20"], <sup>3</sup>)}
            </tbody>
        );
    }

    private renderRow(id: string, title: string, values: string[], titleSuffix: React.ReactNode = null): JSX.Element {
        return (
            <tr key={id} className="body-center">
                <td>{this.getString(title)}{titleSuffix}</td>
                {values.map(value => <td key={`${id}-${value}`}>{value}</td>)}
            </tr>
        );
    }
}

export { BritishColumbiaObstetricalFileWeightGainRecommendationSection };
